module.exports = __webpack_public_path__ + "green-tick.67bbeda815dfc4c03005.png";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1160811329/src/src/assets/images/green-tick.png
// module id = ../../../../../src/assets/images/green-tick.png
// module chunks = main